import moment from "moment";
import React from "react";
import BookingLoggersModal from "./BookingLoggersModal";
import { Placeholder } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";

function ActivityLoggerTable({ data, isLoading }) {
  return (
    <div className="mt-4 shadow rounded">
      <div className="d-flex p-3 border table-head rounded-top">
        <span className="flex-1 fw-bold text-black">First Name</span>
        <span className="flex-1 fw-bold text-black">Delivered Orders</span>
        <span className="flex-1 fw-bold text-black">Session Status</span>
        <span className="flex-1 fw-bold text-black">Booking Status</span>
        <span className="flex-1 fw-bold text-black">Empty Slots</span>
        <span className="flex-1 fw-bold text-black">Agent</span>
        <span className="flex-1 fw-bold text-black">Result</span>
        <span className="flex-1 fw-bold text-black">Created At</span>
      </div>
      {isLoading ? (
        <div>
          {Array.from({ length: 10 }).map((_, index) => (
            <Placeholder
              key={index}
              as="p"
              size="lg"
              animation="glow"
              className={`p-3 border border-top-0 mb-0`}
            >
              <Placeholder xs={12} />
            </Placeholder>
          ))}
        </div>
      ) : data?.length !== 0 && isLoading == false ? (
        data?.map((item, index) => {
          return (
            <div
              className={`d-flex p-3 table-row border border-top-0 ${
                index === 9 && "rounded-bottom"
              }`}
            >
              <span className="flex-1">
                <BookingLoggersModal
                  userName={item?.user?.first_name}
                  record={item}
                />
              </span>
              <span className="flex-1">{item?.delivered_orders_count}</span>
              <span className="flex-1">
                {item?.session_completed ? `Completed` : `Incomplete`}
              </span>
              <span className="flex-1">
                {item?.result === "booking confirmed" ? "Booked" : "Failed"}
              </span>
              <span className="flex-1">
                {item?.emptySlots ? "True" : "False"}
              </span>
              <span className="flex-1">{item?.agent}</span>
              <span className="flex-1">{item?.result}</span>
              <span className="flex-1">
                {moment(item.created_at).format("DD-MM-YYYY HH:mm:ss")}
              </span>
            </div>
          );
        })
      ) : (
        <div className="w-100 d-flex justify-content-center border bg-white">
          <h3 className="p-3 ">Data is not Available</h3>
          <span>
            <NoData />
          </span>
        </div>
      )}
    </div>
  );
}

export default ActivityLoggerTable;
